import type { ProductMM } from '~/entities';

import { mapProductListItemToProductMM } from '../mappers/mapProductListItemToProductMM';
import { productService } from '#shared/api/ke-gateway/product';

const SIZE = 25;

export async function getSimilarProducts(productIds: string[]): Promise<ProductMM[]> {
  try {
    const response = await productService.getSimilar(productIds.join(','), SIZE);
    if (!response) return [];

    return response.map(mapProductListItemToProductMM);
  } catch (e) {
    return [];
  }
}
